export default __webpack_public_path__ + "assets/locales/pt/info.json";